import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const DefinitionListItemKey = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-definition-list__key", className)} {...other}>
      {children}
    </div>
  );
};

DefinitionListItemKey.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

DefinitionListItemKey.defaultProps = {
  className: "",
  children: null
};

export default DefinitionListItemKey;
